<template>
  <div class="schedule-info-item" @click="$emit('view', data.id)">
    <div class="flex" v-if="fullDate">
      <span v-if="startTime.isSame(today, 'year')" class="date">{{ startTime.format("MM-DD dddd") }}</span>
      <span v-else class="date">{{ startTime.format("YYYY-MM-DD dddd") }}</span>
    </div>
    <div class="flex">
      <div>
        <span>{{ startTime.format("HH:mm") }}-{{ endTime.format("HH:mm") }}</span>
        <span class="lesson-type" v-if="data.type === 3">考试</span>
        <span
          class="lesson-type"
          v-if="data.schedule_time_user"
        >{{ data.schedule_time_user.type.name }}</span>
      </div>
      <div v-if="data.teacher" class="teacher">
        <div class="img" :style="$bgd(data.teacher.gravatar)" />
        <span>{{ data.teacher.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScheduleInfoItem",
  props: {
    data: {
      type: Object,
      default: null
    },
    fullDate: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    today() {
      return this.$moment()
    },
    startTime() {
      return this.$moment(this.data.start_time)
    },
    endTime() {
      return this.$moment(this.data.end_time)
    },
  }
}
</script>
<style lang="scss" scoped>
.schedule-info-item {
  padding: 13px 5%;
  margin: 15px auto 0 auto;
  box-shadow: $deep-shadow;
  transition: all 0.1s;
  border: $border;
  border-radius: 10px;
  &:active {
    opacity: 0.6;
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.85rem;
  }
  .lesson-type {
    margin-left: 5px;
    border: 1px solid $blue;
    color: $blue;
    padding: 0 4px;
    font-size: 0.7rem;
    border-radius: 4px;
  }
  .date {
    font-size: 0.8rem;
    opacity: 0.6;
  }
  h4 {
    font-size: 0.85rem;
    font-weight: 400;
  }
  .teacher {
    display: flex;
    align-items: center;
    span {
      // font-size: 0.9rem;
    }
    .img {
      margin-right: 5px;
      $size: 20px;
      width: $size;
      height: $size;
      border-radius: 100%;
    }
  }
}
</style>